export default __webpack_public_path__ + "static/media/invoke-script.b9d481a7.png";